import { render, staticRenderFns } from "./viewField.vue?vue&type=template&id=37cd85f2&scoped=true"
import script from "./viewField.vue?vue&type=script&lang=js"
export * from "./viewField.vue?vue&type=script&lang=js"
import style0 from "./viewField.vue?vue&type=style&index=0&id=37cd85f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cd85f2",
  null
  
)

export default component.exports